export const FRANCHISE_LICENSE_GET = "FRANCHISE_LICENSE_GET";
export const FRANCHISE_LICENSE_GET_SUCCESS = "FRANCHISE_LICENSE_GET_SUCCESS";

export const FRANCHISE_LICENSE_POST = "FRANCHISE_LICENSE_POST";
export const FRANCHISE_LICENSE_POST_SUCCESS = "FRANCHISE_LICENSE_POST_SUCCESS";

export const FRANCHISE_LICENSE_API_ERROR = "FRANCHISE_LICENSE_API_ERROR";